'use client';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { Modal } from '../Modal/Modal';

interface LoadingModalProps {
  isOpen: boolean;
  text?: string;
  size?: 'md' | 'lg' | 'xl' | 'full';
  // Optionally allow disabling close actions while loading
  disableClose?: boolean;
  dataTestId?: string;
}

export const LoadingModal = ({
  isOpen,
  text,
  size = 'md',
  disableClose = true,
  dataTestId = 'loading-modal',
}: LoadingModalProps) => (
  <Modal
    isOpen={isOpen}
    size={size}
    disableClose={disableClose}
    dataTestId={dataTestId}
    className="flex flex-col items-center justify-center py-12"
  >
    <LoadingSpinner />
    {text && <span className="mt-4 text-lg font-semibold">{text}</span>}
  </Modal>
);
